import { CSSProperties } from 'react';
import { IconType } from '.';

interface LockProps extends IconType {
  style?: CSSProperties;
}

export default function Lock({ className = '', color = '#5B667D', height = 11.43, width = 10 }: LockProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 10 11.429" className={className}>
      <path
        fill={color}
        d="M3.214,3.214V4.286H6.786V3.214a1.786,1.786,0,1,0-3.571,0ZM1.786,4.286V3.214a3.214,3.214,0,0,1,6.429,0V4.286h.357A1.43,1.43,0,0,1,10,5.714V10a1.43,1.43,0,0,1-1.429,1.429H1.429A1.43,1.43,0,0,1,0,10V5.714A1.43,1.43,0,0,1,1.429,4.286Z"
      />
    </svg>
  );
}
